{
    "InboundcallsHeader": "Chiamate in entrata",
    "InboundcallsAvgordervalueLabel": "Valore medio dell'ordine:",
    "InboundcallsStrikerateLabel": "Strike Rate (chiamate per ordine):",
    "OutboundcallsHeader": "Chiamate in uscita",
    "OutboundcallsAvgordervalueLabel": "Valore medio dell'ordine:",
    "OutboundcallsStrikerateLabel": "Strike Rate (chiamate per ordine):",
    "MonetaryCallAssignments_SectionHeader": "Assegnazioni di chiamate monetarie",
    "MonetaryCallAssignments_SectionPara": "È possibile controllare il modo in cui vengono calcolate le statistiche finanziarie\/monetarie delle chiamate, assegnando alle chiamate in entrata e in uscita un valore stimato dell'ordine di vendita o un valore monetario, nonché specificando un tasso di risposta alle chiamate come numero di chiamate per vendita\/ordine.",
    "NAME": "MonetaryCallAssignments"
}